import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm, Form } from '@angular/forms';
import { StateService } from '../state.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { FormService } from '../../../form.service';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { tap, catchError } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operator/takeUntil';
import { Subject } from 'rxjs';
import { HttpError } from '../../../errors';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy {
  public administrationData;
  public administrationDataCache;
  private formCode;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private administrationForm: NgForm;

  @ViewChild('administrationForm') set content(content: NgForm) {
    this.administrationForm = content;

    if (content !== undefined) {
      this.administrationForm.statusChanges.takeUntil(this.destroy$).subscribe(result => {
        this.stateService.updateAdministrationState(result === 'VALID');
      });
    }
  }

  constructor(private fb: FormBuilder, private stateService: StateService,
    private route: ActivatedRoute, private formService: FormService, private snackbar: SemsoSnackbarService) { }

  ngOnInit() {
    this.route.params.takeUntil(this.destroy$).subscribe((params) => {
      this.formCode = params['formCode'];
      this.administrationData = this.formService.getStudentAdministrationData(this.formCode)
        .pipe(
          catchError(e => {
            throw this.error(`Fouit bij het ophalen van de administatieinformatie voor formulier: ${this.formCode}`);
          })
        ).subscribe(data => {
          this.administrationData = data;
        });
    }, e => {
      throw this.error('Fout bij het ophalen van de parameters');
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  supplementData(startsWith) {
    this.administrationDataCache = this.formService.getAdministrationDataCache().pipe(
      catchError(e => {
        throw this.error(`Fout bij het ophalen van de cache administatieinformatie voor formulier: ${this.formCode}`);
      })
    ).subscribe(cache => {
      let properties = Object.getOwnPropertyNames(this.administrationData);
      properties.forEach(prop => {
        if (prop.startsWith(startsWith) && prop != 'bpV_Datum') {
          var value = this.administrationData[prop];
          if (value == null || value == '') {
            value = cache[prop];
          }
          this.administrationData[prop] = value;
        }
      });
      this.update(this.administrationData);
    });
  }

  update(data) {
    this.formService.postStudentAdmistrationData(this.formCode, data)
      .takeUntil(this.destroy$)
      .subscribe(
        () => { },
        () => {
          throw this.error(`Fout bij het opslaan van administratiedata voor formulier code: ${this.formCode}`);
        }
      )

    this.stateService.updateAdministrationState(this.administrationForm.form.valid);
  }

  private error(message) {
    this.snackbar.error(message);
    return new HttpError(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/administration/administration.component.ts